import axios from 'axios';
import { getTokenCookieValue } from './requests';
import { API_URL_HERU, API_URL_HERU_NEW_GATEWAY } from 'constants/apis';

type Options = {
	token?: boolean;
	contentType?: string;
	headers?: any;
	isOldGateway?: boolean;
};

const get = async (uri: string, options?: Options) => {
	try {
		const { token, contentType, headers, isOldGateway} = options || {};
		let authorization;
		const newUrl = isOldGateway
			? API_URL_HERU
			: API_URL_HERU_NEW_GATEWAY
		if (token) {
			const accessToken = getTokenCookieValue();
			authorization = `Bearer ${accessToken}`;
		}
		const response = await axios.get(newUrl + uri, {
			headers: {
				'Content-Type': contentType || 'application/json',
				Authorization: authorization,
				...headers,
			},
		});
		return response;
	} catch (error) {
		throw error;
	}
};

const getCustom = async (uri: string) => {
	try {
		const response = await axios.get(`${API_URL_HERU_NEW_GATEWAY}${uri}`, {
			headers: {
				'Content-Type': 'application/json',
			},
		});
		return response;
	} catch (error) {
		throw error;
	}
};

const post = async (uri: string, body: Object, options?: Options) => {
	try {
		const { token, contentType, headers } = options || {};

		let authorization;

		if (token) {
			const accessToken = getTokenCookieValue();
			authorization = `Bearer ${accessToken}`;
		}

		const response = await axios.post(
			`${API_URL_HERU_NEW_GATEWAY}${uri}`,
			body,
			{
				headers: {
					'Content-Type': contentType || 'application/json',
					...headers,
					Authorization: authorization,
				},
			}
		);
		return response;
	} catch (error) {
		throw error;
	}
};

const put = async (uri: string, body: Object, options?: Options) => {
	try {
		const { token, contentType, headers } = options ?? {};
		let authorization;
		if (token) {
			const accessToken = getTokenCookieValue();
			authorization = `Bearer ${accessToken}`;
		}

		const response = await axios.put(
			`${API_URL_HERU_NEW_GATEWAY}${uri}`,
			body,
			{
				headers: {
					'Content-Type': contentType || 'application/json',
					...headers,
					Authorization: authorization,
				},
			}
		);
		return response;
	} catch (error) {
		throw error;
	}
};

const putCsv = async (uri: string, body: string, options?: Options) => {
	try {
		const { token, contentType, headers } = options ?? {};
		let authorization;
		if (token) {
			const accessToken = getTokenCookieValue();
			authorization = `Bearer ${accessToken}`;
		}

		const response = await axios.put(
			`${uri}`,
			body,
			{
				headers: {
					'Content-Type': contentType || 'application/json',
					...headers,
				},
			}
		);
		return response;
	} catch (error) {
		throw error;
	}
};

const postCustom = async (uri: string, body: Object) => {
	try {
		const response = await axios.post(
			`${API_URL_HERU_NEW_GATEWAY}${uri}`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
				},
			}
		);
		return response;
	} catch (error) {
		throw error;
	}
};

const putCustom = async (uri: string, body: Object) => {
	try {
		const response = await axios.put(`${uri}`, body);
		return response;
	} catch (error) {
		throw error;
	}
};

export default { get, getCustom, post, put, postCustom, putCustom, putCsv };
